export default __webpack_public_path__ + "static/media/lancan.63a7eb42.png";